import Info9Content from '../components/info/Info9PageContent';

const Info9Page = () => {
  return <Info9Content />;
};

export default Info9Page;